require('./mortgageRequestUnpaidFeesView.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
import { withRouter } from 'react-router-dom';
// @ helpers
const { formatText } = require('core/i18n').i18n;
// @ Loans
const { okLoansComponents } = require('ok-loans');
// @ components
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const LoanHeader = okLoansComponents.loanHeader;
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const MortgageRequestUnpaidFees = require('components/mortgageRequest/mortgageRequestUnpaidFees/mortgageRequestUnpaidFees');
// @ actions
const unpaidFeesActions = require('actions/mortgageRequest/mortgageRequestUnpaidFees');
const collectiveActions = require('actions/collectives');
// @constants
const {
    MULTICHANNEL_UI_COMPONENT
} = require('constants/index');
// @utilities
const { trackViewAndComercialSpace } = require('../../../utilities/taggingViewHelper');
const { PAGE_LOANS_MORTGAGES } = require("../../../utilities/tagging");

class MortgageRequestUnpaidFeesView extends React.Component {
    constructor(props) {
        super(props);

        this.detailClicked = false;
        this.headerTitle = formatText('mortgageRequestUnpaidFees-title');
        this.breadcrumbText = formatText('mortgageRequestUnpaidFees-breadcrumbText');
        this.handleOnClickDetail = this.handleOnClickDetail.bind(this);
    }

    componentDidMount() {
        const { match: { params: { loanId } }, immLoans, getUnpaidFees, getCollectiveInfo } = this.props;
        const immLoan = immLoans.getIn(['byId', loanId], false);

        this.headerTitle = immLoan ? `${this.headerTitle}${immLoan.get('alias')}` : `${this.headerTitle}${this.breadcrumbText}`;

        if (immLoan) {
            const productType = {
                type: immLoan.get('product'),
                subType: immLoan.get('productSubType'),
                standard: immLoan.get('productStandard')
            };

            getUnpaidFees(immLoan);
            getCollectiveInfo([productType], MULTICHANNEL_UI_COMPONENT);
            trackViewAndComercialSpace({
                immLoan,
                analyticView: (type, subType) => ({
                    pathForTag: PAGE_LOANS_MORTGAGES + "/" + type + "/cuotas impagadas",
                    procType: PAGE_LOANS_MORTGAGES,
                    processDetails: type + "." + subType + "/cuotas impagadas",
                }),
                productImpressionList: 'aresLoanOutstandingPayments'
            });
        }
    }

    componentWillUnmount() {
        this.detailClicked || this.props.cleanUnpaidFees();
    }

    buildBreadcrumb(immLoan) {
        const { immProfile } = this.props;
        let isAresFlag = immProfile.get('isAresUser');
        const loanPrefix = immLoan.get('isPersonal') ? '' : `-${immLoan.get('type')}`;
        return [
            {
                text: formatText(isAresFlag ? 'navbar-aresLoans' : 'navbar-loans'),
                url: isAresFlag ? '/myprofile/loans-mortgages/aresusers' : '/myprofile/loans-mortgages'
            },
            {
                text: immLoan.get('alias'),
                url: isAresFlag ? `/myprofile/loans-mortgages/ares${loanPrefix}-loans/${immLoan.get('loanId')}` : `/myprofile/loans-mortgages/loans/${immLoan.get('loanId')}`
            },
            {
                text: formatText('mortgageRequestUnpaidFees-breadcrumbTitle')
            }
        ];
    }

    handleOnClickDetail() {
        this.detailClicked = true;
    }

    render() {
        const {
            immLoans,
            match: { params: { loanId } },
            mortgageRequestUnpaidFees,
            getUnpaidFees,
            setFilter,
            clearFilter,
            immProfile
        } = this.props
        const immLoan = immLoans.getIn(['byId', loanId], false);
        const breadCrumbData = this.buildBreadcrumb(immLoan);
        let isAresValue = immProfile.get('isAresUser');
        if (immLoan) {
            return (
                <article className="mortgage-request-unpaid-fees-view">
                    <LoanHeader
                        immLoan={immLoan}
                        breadcrumbConfig={breadCrumbData}
                        title={this.headerTitle}
                        showDetails={isAresValue}
                        isMortgage
                        isARES={isAresValue}
                    />
                    <section className="mortgage-request-unpaid-fees-view__body">
                        <div className="row">
                            <div className="col-xs-9">
                                <OKSectionBox>
                                    <MortgageRequestUnpaidFees
                                        immLoan={immLoan}
                                        immMortgageRequestUnpaidFees={mortgageRequestUnpaidFees}
                                        getUnpaidFees={getUnpaidFees}
                                        setFilter={setFilter}
                                        clearFilter={clearFilter}
                                        onClickDetail={this.handleOnClickDetail}
                                        requestNextPage={this.props.nextPage}
                                        isAresFlag={isAresValue}
                                    />
                                </OKSectionBox>
                            </div>
                            {!isAresValue && <div className="col-xs-3">
                                <CommercialAds path="loans-mortgages/loans/:loanId/unpaid-fees" type="cross-selling" />
                            </div>}
                        </div>
                    </section>
                </article>
            );
        }

        return null;
    }
}

MortgageRequestUnpaidFeesView.propTypes = {
    immLoans: PropTypes.object,
    mortgageRequestUnpaidFees: PropTypes.object,
    getCollectiveInfo: PropTypes.func,
    getUnpaidFees: PropTypes.func,
    cleanUnpaidFees: PropTypes.func,
    match: PropTypes.object.isRequired,
    setFilter: PropTypes.func,
    clearFilter: PropTypes.func,
    nextPage: PropTypes.func,
    immProfile: PropTypes.object,
}

module.exports.constructor = MortgageRequestUnpaidFeesView;
module.exports.MortgageRequestUnpaidFeesView = connect(
    state => ({
        immLoans: state.loans,
        mortgageRequestUnpaidFees: state.mortgageRequestUnpaidFees,
        immProfile: state.profile,
    }), {
    getCollectiveInfo: collectiveActions.getCollectiveInfo,
    getUnpaidFees: unpaidFeesActions.getUnpaidFees,
    cleanUnpaidFees: unpaidFeesActions.cleanUnpaidFees,
    setFilter: unpaidFeesActions.setUnpaidFeesFilter,
    clearFilter: unpaidFeesActions.clearUnpaidFeesFilter,
    nextPage: unpaidFeesActions.requestNextTransactionsPage
}
)(withRouter(MortgageRequestUnpaidFeesView));
